export default __webpack_public_path__ + "static/media/bin-red-icon.354d1188.svg";